/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInitiativeRequest
 */
export interface UpdateInitiativeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    intent?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    drivenBy?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    ownerUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInitiativeRequest
     */
    budgetAllocated?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateInitiativeRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateInitiativeRequest
     */
    targetDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdateInitiativeRequest
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInitiativeRequest
     */
    targetMaturity?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    lifecyclePhase?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the UpdateInitiativeRequest interface.
 */
export function instanceOfUpdateInitiativeRequest(value: object): value is UpdateInitiativeRequest {
    return true;
}

export function UpdateInitiativeRequestFromJSON(json: any): UpdateInitiativeRequest {
    return UpdateInitiativeRequestFromJSONTyped(json, false);
}

export function UpdateInitiativeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInitiativeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'intent': json['intent'] == null ? undefined : json['intent'],
        'drivenBy': json['drivenBy'] == null ? undefined : json['drivenBy'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'budgetAllocated': json['budgetAllocated'] == null ? undefined : json['budgetAllocated'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'targetDate': json['targetDate'] == null ? undefined : (new Date(json['targetDate'])),
        'version': json['version'] == null ? undefined : json['version'],
        'status': json['status'] == null ? undefined : json['status'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'lifecyclePhase': json['lifecyclePhase'] == null ? undefined : json['lifecyclePhase'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function UpdateInitiativeRequestToJSON(json: any): UpdateInitiativeRequest {
    return UpdateInitiativeRequestToJSONTyped(json, false);
}

export function UpdateInitiativeRequestToJSONTyped(value?: UpdateInitiativeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'intent': value['intent'],
        'drivenBy': value['drivenBy'],
        'ownerUserId': value['ownerUserId'],
        'budgetAllocated': value['budgetAllocated'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'targetDate': value['targetDate'] == null ? undefined : ((value['targetDate']).toISOString().substring(0,10)),
        'version': value['version'],
        'status': value['status'],
        'capabilityDomain': value['capabilityDomain'],
        'targetMaturity': value['targetMaturity'],
        'lifecyclePhase': value['lifecyclePhase'],
        'effectTenantId': value['effectTenantId'],
    };
}

